import { call, put } from 'redux-saga/effects';
import api from '../../services/api';

import { Creators as TermsOfUseCreators } from '../ducks/termsOfUse';

export function* getTermsOfUse() {
  const response = yield call(api.get, 'v1/sites/terms_of_use');
  if (response.ok) {
    yield put(TermsOfUseCreators.getTermsOfUseSuccess(response.data.terms_of_use));
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/termsOfUse.js